<template>
    <div id="product-advantages" class="d-flex" style="user-select: none">
        <div class="product-advantages-container d-flex">
            <span class="advantages-title text-bold">Troca Grátis</span>
            <span class="advantages-content">Sua primeira troca no site é grátis</span>
        </div>
        <div class="product-advantages-container d-flex">
            <span class="advantages-title text-bold">Frete Grátis</span>
            <div
                class=""
                v-if="
                    $scope.CONFIG.FRETE_VALOR_FIXO_HABILITADO &&
                    $scope.CONFIG.FRETE_VALOR_FIXO === 0
                "
            >
                <span>{{ $t('_shop._advantages.freeShippingTitle') }} </span>
                <span
                    >(<a class="advantages-content text-underline">{{
                        $t('_shop._advantages.freeShippingAnyPurchase')
                    }}</a
                    >)</span
                >
            </div>
            <div class="" v-else>
                <span>Frete grátis a partir de R${{ $scope.CONFIG.VALOR_FRETE_GRATIS }}* </span>
                <span
                    >(<a class="advantages-content text-underline" @click="showRegulamento = true"
                        >Consulte condições</a
                    >)</span
                >
            </div>
        </div>

        <Modal v-model="showRegulamento" class="modal-regulamento">
            <div class="card">
                <div class="card-block card-toolbar">
                    <span class="h5 card-title">Regras para Frete Grátis</span>
                </div>
                <div class="card-block">
                    <Spinner v-if="!shippingControl" />
                    <template v-else>
                        <p>
                            Valor mínimo de compra para frete grátis (já aplicados todos os
                            possíveis descontos):
                        </p>
                        <div>
                            <table class="table-striped mt m-auto">
                                <thead>
                                    <tr>
                                        <th>Estado</th>
                                        <th class="text-center">Sigla</th>
                                        <th class="text-center">Valor Mínimo para Frete Grátis</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in shippingControl" :key="i">
                                        <td>{{ item.name }}</td>
                                        <td class="text-center">{{ item.iso_code }}</td>
                                        <td class="text-center">
                                            {{ $f.formatMoney(item.min_value) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </div>
                <div class="card-block text-right">
                    <button class="btn" type="button" @click="showRegulamento = false">
                        Fechar
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import { initModals } from '../../../common/cr-components';
    import Modal from '../common/container/Modal.vue';
    import { shippingService } from '../../../common/service/resource';
    import Spinner from '@bit/chicorei.chicomponents.feedback.spinner';

    export default {
        name: 'ProductAdvantages',
        components: { Modal, Spinner },

        data() {
            return { showRegulamento: false, shippingControl: null, requests: 0 };
        },

        mounted() {
            initModals();
        },

        watch: {
            showRegulamento(to) {
                if (to && !this.requests && !this.shippingControl) {
                    this.fetchFreeShipping();
                }
            },
        },

        methods: {
            fetchFreeShipping() {
                this.requests++;
                shippingService
                    .query()
                    .then((response) => {
                        this.shippingControl = response.data.data;
                    })
                    .catch(() => {
                        console.log('Erro ao carregar');
                    })
                    .then(() => {
                        this.requests--;
                    });
            },
        },
    };
</script>
